import { render, staticRenderFns } from "./PurchasesPerMonthCompare.vue?vue&type=template&id=77bbdddb"
import script from "./PurchasesPerMonthCompare.vue?vue&type=script&lang=ts"
export * from "./PurchasesPerMonthCompare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77bbdddb')) {
      api.createRecord('77bbdddb', component.options)
    } else {
      api.reload('77bbdddb', component.options)
    }
    module.hot.accept("./PurchasesPerMonthCompare.vue?vue&type=template&id=77bbdddb", function () {
      api.rerender('77bbdddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PurchasesPerMonthCompare.vue"
export default component.exports